/* eslint jsx-a11y/iframe-has-title: 0 */
import React from "react";
import PropTypes from "prop-types";
import GoogleTagManagerScript from "./GoogleTagManagerScript";
import PardotTrackingScript from "./PardotTrackingScript";
import ReactDOMServer from "react-dom/server";
import extend from "lodash/extend";
import { observer } from "mobx-react";
import map from "lodash/map";

@observer
class Layout extends React.Component {
    static propTypes = {
        title: PropTypes.string,
        meta: PropTypes.arrayOf(PropTypes.object),
        stylesheets: PropTypes.arrayOf(PropTypes.string),
        scripts: PropTypes.arrayOf(PropTypes.string),
        mountId: PropTypes.string.isRequired,
        editable: PropTypes.bool,
        googleTagManagerTrackingCode: PropTypes.string,
        sentryUrl: PropTypes.string,
        sentryRelease: PropTypes.string,
        mobx: PropTypes.bool,
        enableGoogleAnalyticsTracking: PropTypes.bool.isRequired,
        enablePardotTracking: PropTypes.bool.isRequired,
        layoutOptions: PropTypes.shape({
            loadFrbTypekitFonts: PropTypes.bool
        })
    }

    static defaultProps = {
        mountId: "view-wrapper",
        mobx: false
    }

    render() {
        const view = React.Children.only(this.props.children);
        const dangerousViewInnerHtml = ReactDOMServer.renderToString(view);
        const pageData = extend({}, this.props.data, {
            content: this.props.content,
            environment: this.props.environment
        });
        const startupScript = {
            __html: "typeof window.__launcher === \"function\" && window.__launcher('"
                    + this.props.mountId
                    + "', JSON.parse(unescape('" + escape(JSON.stringify(this.props.mobx ? pageData : view.props)) + "')), "
                    + Boolean(this.props.editable) + ");"
        };
        const typekitLoadScript = {
            __html: "try{Typekit.load({ async: true });}catch(e){}"
        };
        const sentryInstallationScript = {
            __html: "typeof(Raven) !== \"undefined\" && Raven.config(\"" + this.props.sentryUrl + "\", "
                    + "{release: \"" + this.props.sentryRelease
                    + "\", whitelistUrls: [/https?:\\/\\/((.*)\\.)?gradifi(\\.firstrepublic)?\\.(com|dev|local)/]}).install()"
        };
        const content = this.props.content || {};
        const session = this.props.data ? this.props.data.session : undefined;
        const description = content.metaDescription || (content.common && content.common.metaDescription);
        const keywords = content.metaKeywords || (content.common && content.common.metaKeywords);
        const ogDescription = content.metaOpenGraphDescription || description;
        return (
            <html lang="en-US">
                <head>
                    {this.props.enableGoogleAnalyticsTracking &&
                        <GoogleTagManagerScript
                            trackingCode={this.props.googleTagManagerTrackingCode}
                            session={session}
                        />
                    }
                    {/* TODO Should use this.props.content.title and load shared value from Mongo */}
                    <title>{this.props.title}</title>
                    <meta name="description" content={description} />
                    <meta name="keywords" content={keywords} />
                    <meta name="viewport" content="width=device-width, initial-scale=1" />
                    <meta charSet="utf-8" />
                    <meta property="og:title" content={this.props.title} />
                    <meta property="og:type" content="website" />
                    <meta property="og:description" content={ogDescription} />
                    {this.props.logo && <meta property="og:image" content={this.props.logo} />}
                    {this.props.meta && map(this.props.meta, metaElement => <meta key={metaElement.name || metaElement.property} {...metaElement} />)}
                    {this.props.linkElements && map(this.props.linkElements, linkElement => <link {...linkElement} />)}
                    {this.props.stylesheets && map(this.props.stylesheets, stylesheet => <link key={stylesheet} rel="stylesheet" type="text/css" href={stylesheet} />)}
                    <link rel="icon" href='/favicon.ico' sizes="32x32" type="image/x-icon"/>
                    <script src="https://cdn.ravenjs.com/3.22.1/raven.min.js" crossOrigin="anonymous" />
                    <script type="text/javascript" src="https://cdn.vestwell.com/web-components/help-center/index.js" />
                    <script type="text/javascript" dangerouslySetInnerHTML={sentryInstallationScript} />
                    {this.props.layoutOptions && this.props.layoutOptions.loadFrbTypekitFonts &&
                        <script src="https://use.typekit.net/zth6dzb.js" />
                    }
                    {this.props.layoutOptions && this.props.layoutOptions.loadFrbTypekitFonts &&
                        <script type="text/javascript" dangerouslySetInnerHTML={typekitLoadScript} />
                    }
                </head>
                <body className="gradifi">
                    {this.props.enableGoogleAnalyticsTracking &&
                        <noscript>
                            <iframe src={`https://www.googletagmanager.com/ns.html?id=${this.props.googleTagManagerTrackingCode}`} height="0" width="0" style={{ display: "none", visibility: "hidden" }} />
                        </noscript>
                    }
                    <div id={this.props.mountId} dangerouslySetInnerHTML={{ __html: dangerousViewInnerHtml }} />
                    {/* Load scripts at bottom of page */}
                    {this.props.scripts && this.props.scripts.map(script => <script key={script} src={script} crossOrigin="true" />)}
                    {this.props.enablePardotTracking && <PardotTrackingScript />}
                    {startupScript && <script type="text/javascript" dangerouslySetInnerHTML={startupScript} />}
                </body>
            </html>
        );
    }
}

export default Layout;
